<template>
  <div class="reloanBox">
    <Header :homePage="true" />
    <!-- countdown Box -->
    <div class="countdown">
      <p style="margin-right:0.15rem">
        El orden será inválido hasta
      </p>
      <van-count-down v-show="time" :time="time">
        <template #default="timeData">
          <span class="block">{{ timeData.days }}</span>
          <span class="colon" style="color:#666666">days</span>
          <span class="block">{{
            timeData.hours >= 10 ? timeData.hours : "0" + timeData.hours
          }}</span>
          <span class="colon">:</span>
          <span class="block">{{
            timeData.minutes >= 10 ? timeData.minutes : "0" + timeData.minutes
          }}</span>
          <span class="colon">:</span>
          <span class="block">{{
            timeData.seconds >= 10 ? timeData.seconds : "0" + timeData.seconds
          }}</span>
        </template>
      </van-count-down>
    </div>

    <!-- reloan detail -->
    <div class="reLoanDetail">
      <div class="infoBox">
        <div class="leftInfo">
          <h5>Monto de préstamo</h5>
          <div>
            S/{{
              currentNum
                ? $setNum(currentNum)
                : $setNum(reloanInfo.borrowAmount)
            }}

            <img
              v-show="currentNum"
              style="width: 0.3rem;height: 0.3rem;margin: 0.1rem 0 0 0.05rem;"
              src="../assets/images/upicon2.png"
              alt=""
            />
            <p class="lineText" v-show="currentNum">
              S/{{ $setNum(loanData.unuseCouponBorrowAmount) }}
            </p>
          </div>
        </div>
        <div class="rightInfo">
          <h5>Plazo</h5>
          <p>
            {{ reloanInfo.period }} días
            <img
              v-show="reloanInfo.period > loanData.unuseCouponPeriod"
              style="width: 0.3rem;height: 0.3rem;margin: 0.1rem 0 0 0.05rem;"
              src="../assets/images/upicon2.png"
              alt=""
            />
          </p>
          <p
            class="lineText"
            v-show="reloanInfo.period > loanData.unuseCouponPeriod"
          >
            {{ loanData.unuseCouponPeriod }} días
          </p>
        </div>
      </div>
      <!-- reloan Btn -->
      <div @click="subfrloan" class="reloanBtn">Solicitar un préstamo</div>
    </div>

    <!-- coupon list -->
    <div class="couponBox" @click="openCoupon">
      <!-- 左侧文案 -->
      <div class="leftText">
        <img src="../assets//images/couponIcon.png" alt="" />
        <p>Cupón</p>
      </div>
      <!-- 右侧文案 -->
      <div class="rightText">
        <p v-show="!couponIds.length">Elegir</p>
        <ul v-show="couponIds.length" style="display: flex;">
          <li v-for="item in chooseCouponList">
            <span
              >{{ item.coupon_type == 6 ? "-" : "+"
              }}{{ item.coupon_type == 4 ? "S/" : " " }}</span
            >
            {{ item.distribute_amount }}
            <span style="font-size: 0.26rem;margin-left: 0.03rem;">
              {{ couponAmountText[item.coupon_type] }}
            </span>
          </li>
        </ul>
        <van-icon name="arrow"></van-icon>
      </div>
    </div>

    <!-- protocol -->
    <!-- <p class="protocolBox">
      Acepto las condiciones del
      <a @click="jumpLoanProtocol">contrato de préstamo</a>
    </p> -->

    <!-- trial Detail Box -->
    <div class="trialDetail">
      <h3>Detalles del préstamo</h3>
      <ul>
        <li>
          <p>Fecha de vencimiento</p>
          <p>{{ reloanInfo.firstRepayDateFormat }}</p>
        </li>
        <li>
          <p>Monto de depósito</p>
          <p>S/ {{ $setNum(reloanInfo.borrowAmount) }}</p>
        </li>
        <li>
          <p>Monto de pago</p>
          <p>S/ {{ $setNum(reloanInfo.totalRepayAmount) }}</p>
        </li>
        <li @click="openDetil">
          <p>
            Tasa de interés total
          </p>
          <van-icon
            :style="{
              transform: detailShow ? 'rotate(180deg)' : 'rotate(0)',
              transition: 'all .2s',
            }"
            name="arrow-down"
          />
          <!-- <p>S/ {{ totalInterestRate }}</p> -->
        </li>
        <li
          :style="{
            height: detailShow
              ? loanData.coupon_reduction_amount
                ? '3rem'
                : '2.2rem'
              : '0',
            overflow: 'hidden',
            transition: 'all .2s',
            marginBottom: 0,
            background: '#F5F5F5',
            borderRadius: '0.1rem',
            display: 'block',
          }"
        >
          <ul class="childList">
            <li>
              <p>Interés</p>
              <p>S/ {{ $setNum(reloanInfo.totalInterest) }}</p>
            </li>
            <li>
              <p>Cargo de servicios</p>
              <p>S/ {{ $setNum(reloanInfo.totalServiceFee) }}</p>
            </li>
            <li>
              <p>IGV</p>
              <p>S/ {{ $setNum(reloanInfo.totalGst) }}</p>
            </li>
            <li v-if="loanData.coupon_reduction_amount">
              <p>Importe de la reducción</p>
              <p>S/ {{ $setNum(loanData.coupon_reduction_amount) }}</p>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <van-overlay :show="frConfirmVisible">
      <div class="wrapper">
        <div class="frConfirmBox" @click.stop>
          <img
            class="closeIconImg"
            @click="frConfirmVisible = false"
            src="../assets/images/closeIcon.png"
            alt=""
          />
          <img
            class="titleImg"
            src="../assets/images/frConfirmTitle.png"
            alt=""
          />
          <p>
            Estimado cliente, la solicitud de préstamo que ha presentado ha sido
            revisada y aprobada con éxito. El monto aprobado es de
            <strong>S/{{ $setNum(reloanInfo.borrowAmount) }}</strong> y el plazo
            de préstamo es de <strong>{{ reloanInfo.period }} días</strong>. Por
            favor, haga clic en el botón "Confirmar" y le realizaremos el pago
            del préstamo inmediatamente.
          </p>

          <img
            @click="subfrloan"
            class="confirmBtn"
            src="../assets/images/frConfirmBtn.png"
            alt=""
          />
        </div>
      </div>
    </van-overlay>

    <ContactOrAbout />
  </div>
</template>

<script>
import Header from "../components/header.vue";
import ContactOrAbout from "../components/contactOrAbout.vue";
import {
  orderCalculate,
  loanConfirm,
  getNewInfo,
} from "../utils/api/h5page.js";
export default {
  name: "",
  components: {
    Header,
    ContactOrAbout,
  },
  props: {
    userInfo: {
      type: Object,
    },
  },
  data() {
    return {
      detailShow: false,
      frConfirmVisible: false,
      time: 0,
      couponAmountText: {
        4: "", // 提额
        5: "días", // 延期券
        6: "%", // 折扣券
      },
      reloanInfo: {
        period: 0,
        server_time: "",
        borrowAmount: "",
        totalRepayAmount: "",
        totalInterest: "",
        totalServiceFee: "",
        totalGst: "",
        firstRepayDateFormat: "",
      },
      jsonObj: {},
      couponIds: [],
      chooseCouponList: [],
      currentNum: 0,
      loanData: {},
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.getFrLoanCalculate();
    this.getOrderNewInfo();
  },
  methods: {
    // submit reLoan
    subfrloan() {
      const params = {
        couponIds: this.couponIds.length ? this.couponIds : "",
        borrowAmount: this.reloanInfo.borrowAmount,
      };
      loanConfirm(params).then(({ data }) => {
        console.log("[ data ] >", data);
        if (data.code == 0) {
          this.$emit("getUserInformation");
        }
      });
    },

    // catch loan detail
    openDetil() {
      this.detailShow = !this.detailShow;
    },

    jumpLoanProtocol() {
      let urlparams = encodeURIComponent(JSON.stringify(this.loanData));
      if (window.location.host == "www.mastersol.tech") {
        window.open(
          "https://www.mastersol.tech/h5/loan.html?userInfo=" + urlparams
        );
      } else {
        window.open(
          "https://mastersol.jinglewill.com/211345390/h5/loan.html?userInfo=" +
            urlparams
        );
      }
    },

    // 首贷审核中状态展示信息
    getOrderNewInfo() {
      getNewInfo({ page_step: "2004" }).then(({ data }) => {
        // console.log(data);
        if (data.data.popup) {
          this.frConfirmVisible = true;
        }
      });
    },

    getFrLoanCalculate(couponIds) {
      // accountCouponId: "-1",
      orderCalculate({
        borrowAmount: this.userInfo.loan_amount,
        couponIds: couponIds || "",
      }).then(({ data }) => {
        this.time = data.data.expireMillion;
        this.loanData = data.data;
        for (let i in data.data) {
          for (let row in this.reloanInfo) {
            if (row == i) {
              this.reloanInfo[row] = data.data[i];
            }
          }
        }
        if (data.data.borrowAmount > data.data.unuseCouponBorrowAmount) {
          this.currentNum = data.data.borrowAmount;
        } else {
          this.currentNum = 0;
        }
        this.$emit("closeCoupon");
      });
    },

    openCoupon() {
      this.$emit("openCoupon", 1, this.chooseCouponList);
    },

    // 使用优惠券后
    chooseCoupon(couponIds, couponArr) {
      this.couponIds = couponIds;
      this.chooseCouponList = couponArr;
      this.$emit("openLoading");
      this.getFrLoanCalculate(couponIds);
    },
  },
};
</script>

<style lang="scss" scoped>
.reloanBox {
  padding: 0 0.2rem 0.2rem;
  background-color: #f5f5f5;
}

.countdown {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 0.23rem;
  color: #666666;
  padding: 0.2rem 0 0.32rem;
  .colon {
    display: inline-block;
    margin: 0 0.12rem;
    color: #dddddd;
  }
  .block {
    display: inline-block;
    width: 0.45rem;
    height: 0.45rem;
    line-height: 0.45rem;
    color: #fff;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.26rem;
    text-align: center;
    border-radius: 0.08rem;
    background-color: #ffd347;
  }
}

.reLoanDetail {
  // width: 100%;
  padding: 0.7rem 0.5rem 0.4rem;
  background: #c90000;
  border-radius: 0.2rem;
  .infoBox {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.69rem;
    .leftInfo {
      & > div {
        width: max-content;
        font-family: Roboto, Roboto;
        font-weight: 500;
        font-size: 0.5rem;
        color: #ffffff;
      }
    }
    h5 {
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 0.28rem;
      color: #ffffff;
      margin-bottom: 0.3rem;
    }
    p {
      font-family: Roboto, Roboto;
      font-weight: 500;
      font-size: 0.5rem;
      color: #ffffff;
    }

    .lineText {
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 0.24rem;
      color: #e17575;
      line-height: 0.28rem;
      text-align: center;
      text-decoration-line: line-through;
      margin-right: 0.3rem;
    }
  }

  .reloanBtn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 5.8rem;
    height: 0.8rem;
    background: #ffffff;
    box-shadow: inset 0rem 0.16rem 0.32rem 0rem rgba(255, 255, 255, 0.22);
    border-radius: 0.4rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 700;
    font-size: 0.32rem;
    color: #333333;
  }
}

.couponBox {
  width: 100%;
  height: 0.8rem;
  border-radius: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0.2rem 0;
  background: #fff;
  border-top: 0.02rem dashed #e9e9e9;
  padding: 0 0.2rem;
  .leftText {
    display: flex;
    align-items: center;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.26rem;
    color: #333333;
    img {
      width: 0.4rem;
      height: 0.4rem;
      margin-right: 0.15rem;
    }
  }
  .rightText {
    display: flex;
    align-items: center;
    p {
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 0.26rem;
      color: #666666;
      margin-right: 0.1rem;
    }
    .van-icon {
      color: #666666;
      font-size: 0.3rem;
    }

    ul {
      display: flex;
      li {
        padding: 0.05rem 0.1rem;
        background: #1e1e1e;
        border-radius: 0.1rem;
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 0.25rem;
        color: #ffffff;
        margin-right: 0.1rem;
      }
    }
  }
}

.trialDetail {
  // width: 100%;
  background: #ffffff;
  border-radius: 0.2rem;
  padding: 0.34rem 0.24rem;
  margin: 0.3rem 0;
  h3 {
    font-family: Roboto, Roboto;
    font-weight: 700;
    font-size: 0.32rem;
    color: #333333;
    margin-bottom: 0.4rem;
  }
  ul {
    li {
      display: flex;
      justify-content: space-between;
      margin-bottom: 0.3rem;
      p {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 0.26rem;
        color: #333333;
      }
      .van-icon-arrow-down {
        font-size: 0.32rem;
      }
      .childList {
        padding: 0.31rem 0.24rem;
        li {
          p {
            font-family: Roboto, Roboto;
            font-weight: 400;
            font-size: 0.24rem;
            color: #666666;
          }
          &:last-child {
            margin: 0;
          }
        }
      }
    }
  }
}

.protocolBox {
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 0.22rem;
  color: #999999;
  text-align: center;
  margin-top: 0.3rem;
  a {
    color: #333333;
    text-decoration: underline;
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .frConfirmBox {
    position: relative;
    background: url("../assets/images/frConfirmBgc.png") no-repeat;
    background-size: 100% 100%;
    width: 5.4rem;
    height: 6.26rem;
    .closeIconImg {
      position: absolute;
      top: -0.92rem;
      right: 0.27rem;
      width: 0.4rem;
      height: 0.4rem;
    }
    .titleImg {
      display: block;
      width: 100%;
      margin-top: 0.23rem;
    }
    p {
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 0.24rem;
      color: #333333;
      width: 4.37rem;
      margin: 0 auto 0.7rem;
      text-align: center;
    }

    .confirmBtn {
      display: block;
      margin: 0 auto;
      width: 3.04rem;
      height: 0.94rem;
    }
  }
}
</style>
